import { React, UseState, UseEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageContent from 'layouts/PageContent';
import WireSteelGeneralView from './WireSteelGeneralView';

const WireSteelGeneralViewScreen = (props) => {
  const {t, i18n} = useTranslation(['salesPerformance', 'common']);
  
  return (
    <PageContent title={t('salesPerformance:SpreadDashboard')}>
      <WireSteelGeneralView />
    </PageContent>
  )
}

export default WireSteelGeneralViewScreen;